import { NavLink, Outlet } from 'react-router-dom';
import { Bell, LogOut } from 'lucide-react';
import { useAuthStore } from '@/stores/auth.store';
import { useLogout } from '@/features/auth/use-auth';
import { cn } from '@/lib/utils';

const NAV = [
  { to: '/', label: 'Dashboard', end: true },
  { to: '/empresas', label: 'Empresas' },
  { to: '/operadores', label: 'Operadores' },
];

/**
 * Shell del operador: NAVBAR SUPERIOR horizontal sobre fondo claro azul (no
 * sidebar). Distinto a propósito de la app del tenant.
 */
export function AdminShell(): JSX.Element {
  const user = useAuthStore((s) => s.user);
  const logout = useLogout();
  const initial = (user?.name ?? 'O').charAt(0).toUpperCase();

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-30 px-3 lg:px-8 pt-3 lg:pt-4">
        <div className="mx-auto max-w-7xl h-16 flex items-center gap-3 rounded-2xl border border-border bg-card px-3 lg:px-6 shadow-sm">
          <div className="flex items-center gap-2 shrink-0">
            <div className="h-9 w-9 rounded-xl bg-gradient-to-br from-primary to-cyan-400 grid place-items-center text-white font-bold shadow-sm">
              C
            </div>
            <span className="font-semibold tracking-tight hidden sm:block">
              Cajita <span className="text-muted-foreground font-normal">· Operador</span>
            </span>
          </div>

          <nav className="flex items-center gap-1 ml-1 overflow-x-auto">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                className={({ isActive }) =>
                  cn(
                    'whitespace-nowrap rounded-full px-3.5 lg:px-4 py-2 text-sm font-medium transition-colors',
                    isActive
                      ? 'bg-primary text-primary-foreground shadow-sm shadow-primary/30'
                      : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground',
                  )
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-2 lg:gap-3">
            <button
              type="button"
              className="h-9 w-9 grid place-items-center rounded-full text-muted-foreground hover:bg-accent"
              aria-label="Notificaciones"
            >
              <Bell className="h-[18px] w-[18px]" />
            </button>
            <div className="flex items-center gap-2 pl-1 lg:pl-2 border-l border-border">
              <div className="h-9 w-9 rounded-full bg-primary/15 text-primary grid place-items-center text-sm font-semibold">
                {initial}
              </div>
              <div className="hidden md:block leading-tight">
                <p className="text-sm font-medium">{user?.name}</p>
                <p className="text-[11px] text-muted-foreground">Operador de plataforma</p>
              </div>
              <button
                type="button"
                onClick={() => logout.mutate()}
                title="Cerrar sesion"
                className="h-9 w-9 grid place-items-center rounded-full text-muted-foreground hover:bg-accent"
              >
                <LogOut className="h-[18px] w-[18px]" />
              </button>
            </div>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-7xl px-3 lg:px-8 py-6">
        <Outlet />
      </main>
    </div>
  );
}
